import React, { useEffect } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import './TermsConditions.css';
import Topbar from './Topbar';

export default function TermsConditions() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  return (
    <>
     
      <Navbar />
      <section className="TermsConditions">
        <h1 id="TC">Terms and Conditions</h1>
        <p>Welcome to Shiva Nadi Astrology! By using our services, you agree to the following terms and conditions.</p>

        <h2>1. Introduction</h2>
        <p>These Terms and Conditions govern the use of services provided by Shiva Nadi Astrology. By accessing our services, you accept these terms in full.</p>

        <h2>2. Services Offered</h2>
        <p>We provide astrological services including Nadi readings, horoscope consultations, and personalized predictions. Our services aim to guide and enlighten customers worldwide.</p>

        <h2>3. User Responsibilities</h2>
        <p>Users are responsible for providing accurate birth details, including name, date, time, and place of birth. Accurate details ensure the precision of astrological readings.</p>

        <h2>4. Service Availability</h2>
        <p>Our services are available globally and are conducted online and offline based on user preferences. Availability may vary based on scheduling and time zones.</p>

        <h2>5. Pricing</h2>
        <p>All service charges are communicated upfront. Fees may vary depending on the type of astrological service selected. Additional charges may apply for premium or expedited services.</p>

        <h2>6. Payments</h2>
        <p>Payments must be made in advance to confirm bookings. We accept various payment methods, including credit/debit cards, bank transfers, and online payment gateways.</p>

        <h2>7. Cancellations</h2>
        <p>Users can cancel or reschedule their appointments by notifying us at least 24 hours in advance. Cancellation fees may apply for last-minute changes.</p>

        <h2>8. Warranty</h2>
        <p>Our astrological services are based on ancient texts and calculations. While we strive for accuracy, results may vary and are not guaranteed due to the interpretative nature of astrology.</p>

        <h2>9. Limitation of Liability</h2>
        <p>Shiva Nadi Astrology shall not be held liable for any decisions or outcomes resulting from astrological consultations. Users are advised to exercise their own discretion.</p>

        <h2>10. Customer Support</h2>
        <p>If you have any questions or concerns regarding our services, please contact our support team. We are here to assist you with any inquiries.</p>

        <h2>11. Modifications</h2>
        <p>Shiva Nadi Astrology reserves the right to modify these terms at any time. Changes will be communicated to users through our website or via email.</p>

        <h2>12. Governing Law</h2>
        <p>These terms shall be governed by and construed in accordance with the laws of the applicable jurisdiction in which Shiva Nadi Astrology operates.</p>

        <h2>13. Privacy Policy</h2>
        <p>Your privacy is important to us. Please refer to our Privacy Policy for details on how we collect, use, and protect your information.</p>

        <h2>14. Termination</h2>
        <p>Shiva Nadi Astrology reserves the right to suspend or terminate services for any user who violates these terms or engages in unlawful behavior.</p>

        <h2>15. Contact Us</h2>
        <p>If you have any questions about these Terms and Conditions, please contact us at <a href="mailto:shivanadiastrologer@gmail.com">shivanadiastrologer@gmail.com</a>.</p>
      </section>
      <Footer />
    </>
  );
}
